/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
} from 'reactstrap';

import { useState, useContext } from 'react';
import { GlobalContext } from '../api/GlobalContext';
import { useNavigate } from 'react-router-dom';

const ResetEmail = () => {
  // Get the API
  const { apiClient } = useContext(GlobalContext);

  // Get the navigation function
  const navigate = useNavigate();

  // // State variable to store the label text
  const [labelText, setLabelText] = useState('Reset Password');

  // State variables to store the form input values
  const [email, setEmail] = useState('');
  const [disableSend, setDisableSend] = useState(false);
  const [disableIsSendingEmail, setIsSendingEmail] = useState(false);

  // Function to handle form submission
  function handleSubmit(e) {
    e.preventDefault();
    setDisableSend(true);
    setIsSendingEmail(true);

    //RegEx for email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    //check if email format is valid
    if (!emailRegex.test(email)) {
      setLabelText(
        'Invalid email format. Please provide a valid email address',
      );
      setDisableSend(false);
      return;
    }
    // Tell the user we got their request
    setLabelText('Sending email to reset password...');

    // Call the sendResetPasswordEmail function with the form values
    apiClient
      .sendResetPasswordEmail(email)
      .then((data) => {
        if ('error' in data) {
          setLabelText(data['error']);
          setDisableSend(false);
          setIsSendingEmail(false);
        } else {
          setLabelText(
            'You will receive an email with instructions to reset your password if an account exists for this email address.',
          );
          setTimeout(() => {
            navigate('/auth/login');
          }, 5000);
          setDisableSend(true);
          setIsSendingEmail(false);
        }
      })
      .catch((e) => {
        setLabelText('Error: ' + e);
        setDisableSend(false);
        setIsSendingEmail(false);
      });
  }

  return (
    <>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>{labelText}</small>
            </div>
            <Form role="form" onSubmit={handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-email-83" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Your Comprehend PT account Email"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <div className="text-center">
                <Button
                  className="my-4"
                  color="primary"
                  type="submit"
                  disabled={disableIsSendingEmail || disableSend}
                >
                  Send
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default ResetEmail;
